import { type AnswerCard } from "../../types/game";
import { AnswerCardList } from "../AnswerCard";

interface AnswerSelectionSectionProps {
  answerOptions: AnswerCard[];
  selectedAnswerIndex: number | null;
  onSelectAnswer: (index: number) => void;
}

export function AnswerSelectionSection({
  answerOptions,
  selectedAnswerIndex,
  onSelectAnswer,
}: AnswerSelectionSectionProps) {
  return (
    <div
      className="glass rounded-lg p-4 sm:p-6 mb-6"
      data-testid="game-answer-selection-section"
    >
      <h2 className="font-display text-xl sm:text-2xl font-bold mb-3 sm:mb-4">
        Choose an Answer Card
      </h2>
      {answerOptions.length === 0 ? (
        <div className="text-center py-6 sm:py-8 text-yellow-400">
          <p className="text-base sm:text-lg font-medium mb-2">
            No answer cards available
          </p>
          <p className="text-xs sm:text-sm text-gray-400">
            This might be a sync issue. Try refreshing the page or check server
            logs.
          </p>
        </div>
      ) : (
        <AnswerCardList
          cards={answerOptions}
          selectedIndices={
            selectedAnswerIndex !== null ? [selectedAnswerIndex] : []
          }
          onCardClick={onSelectAnswer}
        />
      )}
    </div>
  );
}
